import { FormControl, IconButton, InputAdornment, MenuItem, Select, TextField } from "@mui/material";
import Cookies from "js-cookie";
import { Home, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useYojanaSelect } from "../../API_Master/FetchAPI";
import { useSetGramYojanaMembers } from "../../API_Master/MutateAPI";
import TableShimmer from "../../Components/TableShimmer";
import { handleKeyDownNumber, handlePaste, notifyError, notifySuccess } from "../../MethodMaster/JSXComponentMothod";

const YojanaSelect = ({ show, handleClose, memberDetails, familyHeadMasterID, memberYojanaDetail, refetchMemberList }) => {
  const { data: YojanaData = [], isFetching } = useYojanaSelect(show);
  const [gramYojanaData, setGramYojanaData] = useState([]);
  const [searchYojana, setSearchYojana] = useState("");
  const { mutate: addGramYojanaMember, isPending: inserting } = useSetGramYojanaMembers();

  console.log("memberDetaislDeaerasdfasdf", memberDetails);

  useEffect(() => {
    if (show && YojanaData.length > 0) {
      setGramYojanaData(
        YojanaData.map((yojana) => {
          let FamilyDetail = [];
          const availableYojana = memberYojanaDetail?.find((item) => item?.GramYojnaID?.toString() === yojana?.GramYojnaID.toString());
          if (availableYojana) {
            FamilyDetail = availableYojana?.MemberDetails?.map((ele) => {
              return {
                GramYojnaMemberID: ele?.GramYojnaMemberID || "",
                FamilyMemberDetailID: ele?.FamilyMemberDetailID || "",
                ContactDetailID: ele?.ContactDetailID || "",
                VoterID: ele?.VoterID?.toString() || "",
                Amounts: ele?.Amount?.toString() || "",
                GramYojnaAmountDetailIDs: ele?.GramYojnaAmountDetailID?.toString() || "",
              };
            });
          }
          return {
            ...yojana,
            // FamilyDetail: FamilyDetail,
            FamilyDetail: [],
          };
        })
      );
    }
  }, [show, YojanaData, memberYojanaDetail]);

  console.log("checkingTheValueofGramYojana", gramYojanaData);

  const handleAddMemberToGramYojana = (yojanaIndex, member, yojanaAmountDetails = []) => {
    let updatedMember = member;

    if (yojanaAmountDetails && yojanaAmountDetails.length === 1) {
      updatedMember = {
        ...member,
        Amounts: yojanaAmountDetails[0].Amount,
        GramYojnaAmountDetailIDs: yojanaAmountDetails[0].GramYojnaAmountDetailID?.toString(),
        GramYojnaMemberID: "",
      };
    }

    setGramYojanaData((prev) =>
      prev.map((item, index) => {
        if (index === yojanaIndex) {
          const isMemberPresent = item?.FamilyDetail?.some((ele) => ele.VoterID === member.VoterID);

          return {
            ...item,
            FamilyDetail: isMemberPresent ? item?.FamilyDetail?.filter((ele) => ele.VoterID !== member.VoterID) : [...item.FamilyDetail, updatedMember],
          };
        }
        return item;
      })
    );
  };

  const handleAmountSelect = (yojanaIndex, amount, GramYojnaAmountDetailID, member) => {
    console.log("sdfsdfjasfjsakfjsadf", yojanaIndex, amount, GramYojnaAmountDetailID, member);
    setGramYojanaData((prev) =>
      prev.map((yojana, idx) => {
        if (idx === yojanaIndex) {
          const updatedFamily = yojana?.FamilyDetail.map((ele) =>
            ele.VoterID === member.VoterID ? { ...ele, Amounts: amount, GramYojnaAmountDetailIDs: GramYojnaAmountDetailID?.toString() } : ele
          );
          return { ...yojana, FamilyDetail: updatedFamily };
        }
        return yojana;
      })
    );
  };

  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const handleSubmit = () => {
    const LabharthiData = gramYojanaData?.filter((ele) => ele?.FamilyDetail?.length > 0);

    if (LabharthiData?.length === 0) {
      notifyError("Please Select Atleast one yojana to proceed");
      return;
    }

    const missingAmount = LabharthiData.some((yojana) => {
      return (
        (Array.isArray(yojana.AmountDetails) &&
          yojana.AmountDetails.length > 0 &&
          yojana.FamilyDetail.some((member) => !member.Amounts || member.Amounts === "" || !member.GramYojnaAmountDetailIDs || member.GramYojnaAmountDetailIDs === "")) ||
        (yojana?.IsAmountEnterByUser && yojana.FamilyDetail.some((member) => !member.Amounts || member.Amounts === ""))
      );
    });

    if (missingAmount) {
      notifyError("Please select Amount for all members before proceeding");
      return;
    }
    const LabharthiFamilyDetail = LabharthiData?.map((ele) => {
      const FamilyDetailsArr = ele?.FamilyDetail?.map((ele2) => {
        return {
          ...ele2,
          TotalAmount: ele?.TimePeriod && ele?.TimePeriod != "1" ? parseInt(ele2.Amounts) * parseInt(ele?.TimePeriod) : ele2.Amounts,
        };
      });
      return {
        ...ele,
        FamilyDetail: FamilyDetailsArr,
      };
    });

    const payload = {
      UserID: Cookies.get("Mukesh_Patel_UserID") || "",
      FamilyHeadMasterID: familyHeadMasterID,
      LabharthiFamilyDetail: LabharthiFamilyDetail,
      CreatedByUserID: Cookies.get("Mukesh_Patel_UserID") || "",
    };

    addGramYojanaMember(payload, {
      onSuccess: (res) => {
        if (res?.status === true) {
          notifySuccess("Successfully Inserted", false);
          handleClose();
          refetchMemberList();
        } else {
          notifyError(res?.message ? res.message : "Data Not Inserted", false);
        }
      },
      onError: (err) => {
        const errorMessage = err?.message || "Failed to assign system";
        console.error(err);
        notifyError(errorMessage || "Something went wrong", false);
      },
    });
  };

  const handleSelectAllMembers = (gramYojanaID, members, isChecked, amountDetails = []) => {
    setGramYojanaData((prev) =>
      prev.map((yojana, idx) => {
        // if (idx === yojanaIndex) {
        if (yojana?.GramYojnaID === gramYojanaID) {
          if (isChecked) {
            // Select all members
            const updatedMembers = members.map((member) => {
              let updatedMember = member;
              if (amountDetails?.length === 1) {
                updatedMember = {
                  ...member,
                  Amounts: amountDetails[0].Amount,
                  GramYojnaAmountDetailIDs: amountDetails[0].GramYojnaAmountDetailID?.toString(),
                  GramYojnaMemberID: "",
                };
              } else {
                updatedMember = {
                  ...member,
                  Amounts: member?.Amounts || "",
                  GramYojnaAmountDetailIDs: member?.GramYojnaAmountDetailIDs || "",
                  GramYojnaMemberID: member?.GramYojnaMemberID || "",
                };
              }
              return updatedMember;
            });
            return { ...yojana, FamilyDetail: updatedMembers };
          } else {
            // Deselect all
            return { ...yojana, FamilyDetail: [] };
          }
        }
        return yojana;
      })
    );
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl" dialogClassName="custom-modal-width" scrollable>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex gap-2 align-items-end mt-2 ">
              <div className="fw-bold fs-large ">Yojanas</div>
              <TextField
                value={searchYojana}
                onChange={(e) => setSearchYojana(e.target.value)}
                placeholder="Search Yojana..."
                size="small"
                sx={{ maxWidth: 200 }}
                InputProps={{
                  endAdornment: searchYojana && (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setSearchYojana("")} edge="end" size="small">
                        <X size={16} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isFetching ? (
            <TableShimmer theme={"light"} />
          ) : (
            <table className="datatables-users table dataTable dtr-column" id="DataTables_Table_0">
              <thead className="table-header-light border-top" id="tblHead">
                <tr>
                  <th style={{ width: "5%", verticalAlign: "middle", textAlign: "center" }}>Sr No</th>
                  <th style={{ width: "15%", verticalAlign: "middle" }}>
                    <Home size={16} className="me-1" /> Yojana
                  </th>
                  <th style={{ width: "10%" }}>Select All</th>
                  <th colSpan={4} style={{ textAlign: "center", width: "70%" }}>
                    Member
                  </th>
                </tr>
              </thead>
              <tbody>
                {YojanaData?.filter((ele) => ele?.GramYojnaName?.includes(searchYojana))?.map((Yojana, YojanaIndex) => {
                  const members = memberDetails || [];
                  const memberChunks = chunkArray(members, 4);
                  const yojanaAmountList = Array.isArray(Yojana?.AmountDetails) ? Yojana?.AmountDetails : [];
                  console.log("sdfsdfsafsafasfasf", yojanaAmountList);
                  return memberChunks?.length > 0 ? (
                    <>
                      {memberChunks?.map((chunk, chunkIndex) => (
                        <>
                          {chunkIndex === 0 && yojanaAmountList?.length > 1 && (
                            <tr>
                              <td colSpan={7}>
                                <div className="yojana-note-box">
                                  💡 કૃપા કરીને સભ્યો પસંદ કરો અને
                                  <span className="yojana-highlight">{Yojana.GramYojnaName}</span>
                                  માટે તેમની સંબંધિત રકમ પસંદ કરો.
                                </div>
                              </td>
                            </tr>
                          )}

                          <tr key={`${YojanaIndex}-${chunkIndex}`} className="align-top">
                            {chunkIndex === 0 && (
                              <>
                                <td rowSpan={memberChunks?.length}>{YojanaIndex + 1}</td>
                                <td rowSpan={memberChunks?.length} className="yojana-name ">
                                  {Yojana?.GramYojnaName || ""}
                                </td>
                                <td rowSpan={memberChunks?.length}>
                                  {yojanaAmountList?.length <= 1 && (
                                    <div className="d-flex align-items-center gap-2">
                                      <input
                                        type="checkbox"
                                        id={`select-all-${YojanaIndex}`}
                                        className="cursor-pointer"
                                        checked={gramYojanaData[YojanaIndex]?.FamilyDetail?.length === members.length && members.length > 0}
                                        // onChange={(e) => handleSelectAllMembers(YojanaIndex, members, e.target.checked, Yojana?.AmountDetails)}
                                        onChange={(e) => handleSelectAllMembers(Yojana?.GramYojnaID, members, e.target.checked, Yojana?.AmountDetails)}
                                      />
                                      <label htmlFor={`select-all-${YojanaIndex}`} className="cursor-pointer small fw-semibold text-secondary">
                                        Select All
                                      </label>
                                    </div>
                                  )}
                                </td>
                              </>
                            )}

                            {chunk?.map((member) => {
                              const memberData = gramYojanaData[YojanaIndex]?.FamilyDetail?.find((ele) => ele.VoterID === member.VoterID) || {};

                              return (
                                <>
                                  <td key={member?.VoterID} style={{ width: `${70 / 4}%` }}>
                                    <div className="d-flex flex-column gap-1 p-1 border rounded">
                                      <div className="d-flex align-items-center gap-1">
                                        <input
                                          id={`${YojanaIndex}-${member.VoterID}`}
                                          type="checkbox"
                                          className="cursor-pointer select-yojana-input"
                                          checked={!!memberData?.VoterID}
                                          onChange={() => handleAddMemberToGramYojana(YojanaIndex, member, Yojana?.AmountDetails)}
                                        />
                                        <label className="cursor-pointer yojana-select-member-name" htmlFor={`${YojanaIndex}-${member?.VoterID}`}>
                                          {member?.FullNameEnglish}
                                        </label>
                                      </div>

                                      {Yojana?.IsAmountEnterByUser ? (
                                        <input
                                          type="text"
                                          maxLength={10}
                                          className="form-control"
                                          value={
                                            gramYojanaData[YojanaIndex]?.FamilyDetail?.find((ele) => ele.VoterID === member.VoterID)?.Amounts ||
                                            (yojanaAmountList.length === 1 ? yojanaAmountList[0].Amount : "") ||
                                            ""
                                          }
                                          disabled={!gramYojanaData[YojanaIndex]?.FamilyDetail?.some((ele) => ele.VoterID === member.VoterID)}
                                          placeholder="Enter Amount"
                                          onKeyDown={handleKeyDownNumber}
                                          onPaste={handlePaste}
                                          onChange={(e) => handleAmountSelect(YojanaIndex, e.target.value, null, member)}
                                        />
                                      ) : yojanaAmountList?.length > 0 ? (
                                        <FormControl size="small" sx={{ minWidth: 100 }}>
                                          <Select
                                            displayEmpty
                                            value={
                                              gramYojanaData[YojanaIndex]?.FamilyDetail?.find((ele) => ele.VoterID === member.VoterID)?.Amounts ||
                                              (yojanaAmountList.length === 1 ? yojanaAmountList[0].Amount : "") ||
                                              ""
                                            }
                                            disabled={!gramYojanaData[YojanaIndex]?.FamilyDetail?.some((ele) => ele.VoterID === member.VoterID)}
                                            onChange={(e) =>
                                              handleAmountSelect(
                                                YojanaIndex,
                                                e.target.value,
                                                yojanaAmountList.find((amt) => amt.Amount === e.target.value)?.GramYojnaAmountDetailID,
                                                member
                                              )
                                            }
                                            sx={{
                                              "&.Mui-disabled": {
                                                backgroundColor: "#e4e2e27c",
                                                color: "#555",
                                                borderRadius: "6px",
                                              },
                                            }}
                                          >
                                            {/* 👇 Placeholder */}
                                            <MenuItem value="" disabled>
                                              <em>Select Amount</em>
                                            </MenuItem>

                                            {/* 👇 Actual options */}
                                            {yojanaAmountList?.map((amt) => (
                                              <MenuItem key={amt.GramYojnaAmountDetailID} value={amt.Amount}>
                                                {amt.Amount}
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </td>
                                </>
                              );
                            })}

                            {chunk?.length < 4 &&
                              Array(4 - chunk?.length)
                                .fill(null)
                                .map((_, i) => <td key={`empty-${i}`} style={{ width: `${70 / 4}%` }} />)}
                          </tr>
                        </>
                      ))}
                    </>
                  ) : (
                    <tr key={YojanaIndex}>
                      <td>{YojanaIndex + 1}</td>
                      <td>{Yojana?.GramYojnaName}</td>
                      <td colSpan={4} className="text-center text-muted">
                        No members found
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="mt-2" variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button className="mt-2" variant="primary" onClick={handleSubmit} disabled={inserting}>
            {inserting ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* {isFetching && <Loader />} */}
    </>
  );
};

export default YojanaSelect;
